export default "__VITE_ASSET__B2Yik7vg__"